module.exports = ":host {\n  width: 100%; }\n"